import { render, staticRenderFns } from "./mywalletlist.vue?vue&type=template&id=520c1b06&scoped=true&"
import script from "./mywalletlist.vue?vue&type=script&lang=js&"
export * from "./mywalletlist.vue?vue&type=script&lang=js&"
import style0 from "./mywalletlist.vue?vue&type=style&index=0&id=520c1b06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c1b06",
  null
  
)

export default component.exports